// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightColumn":"_2qjOtN","feedbackSuccessIcon":"_1OGE12","textTitle":"_1h_8-c","reviewerEditorWrapper":"lE28oi","renderToolTip":"pcU2Jz"};